import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'help_center-search_enter-keyboard_input';

/**
 * Hit enter event from search bar field in help center
 */
export function trackHelpCenterSearchEnterKeyboardInput(
  current_path: string,
  SectionFrom2: string = ''
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { current_path, SectionFrom2 },
  });
}
